import { actionTypes } from './constants';

import { isProductValid } from 'src/util/util';
const initialState = {
  cart: [],
  total: 0,
  // local
  totalAmount: 0,
  totalPrice: 0,
  allChecked: false,
};


function isAllChecked(cart) {
  for (let i = 0; i < cart.length; i++) {
    const item = cart[i];
    if (!item.checked && isProductValid(item.product)) {
      return false;
    }
  }
  return true;
}

function calcaTotalAmountAndTotalPrice(cart) {
  let totalAmountTemp = 0, totalPriceTemp = 0;
  for (let i = 0; i < cart.length; i++) {
    const item = cart[i];
    if (item.checked) {
      totalAmountTemp += item.amount;
      totalPriceTemp += (item.amount * item.product.price);
    }
  }
  return { totalAmount: totalAmountTemp, totalPrice: totalPriceTemp };
}

function toggleCheckItem(cart, cartItemId) {
  const cartTemp = cart.slice();
  for (let i = 0; i < cartTemp.length; i++) {
    const item = cartTemp[i];
    if (item.id === cartItemId) {
      item.checked = !item.checked;
    }
  }
  return cartTemp;
}
function toggleCheckAll(cart, allChecked) {
  if (!cart || cart.length === 0) {
    return false;
  }
  const cartTemp = cart.slice();
  for (let i = 0; i < cartTemp.length; i++) {
    const item = cartTemp[i];
    if (isProductValid(item.product)) {
      item.checked = !allChecked;
    }
  }
  return cartTemp;
}
function changeProductNumber(cart, changeItem) {
  const cartTemp = cart.slice();
  const cartItem = cartTemp.find(item => item.id === changeItem.id);
  if (cartItem) {
    cartItem.amount = changeItem.amount;
  }
  return cart;
}
function deleteProducts(cart, cartItemIds) {
  const cartTemp = cart.slice();
  for (let i = 0; i < cartTemp.length; i++) {
    const item = cartTemp[i];
    const idIndex = cartItemIds.findIndex(id => id === item.id);
    if (idIndex !== -1) {
      cartTemp.splice(i--, 1);
      cartItemIds.splice(idIndex, 1);
    }
  }
  return cartTemp;
}

function handleToggleCheckItem(state, action) {
  const cart = toggleCheckItem(state.cart, action.data.cartItemId);
  const allChecked = isAllChecked(cart);
  const { totalAmount, totalPrice } = calcaTotalAmountAndTotalPrice(cart);
  return { ...state, cart, totalAmount, totalPrice, allChecked };
}
function handleToggleCheckAll(state, action) {
  const cart = toggleCheckAll(state.cart, state.allChecked);
  const { totalAmount, totalPrice } = calcaTotalAmountAndTotalPrice(cart);
  return { ...state, cart, totalAmount, totalPrice, allChecked: !state.allChecked };
}
function handleChangeProductNumber(state, action) {
  const cart = changeProductNumber(state.cart, action.data);
  const { totalAmount, totalPrice } = calcaTotalAmountAndTotalPrice(cart);
  const total = calcaTotal(cart);
  return { ...state, total, cart, totalAmount, totalPrice };
}
function handleDeleteProducts(state, actions) {
  const cartItemIds = actions.data.ids;
  const cart = deleteProducts(state.cart, cartItemIds);
  const { totalAmount, totalPrice } = calcaTotalAmountAndTotalPrice(cart);
  const total = calcaTotal(cart);
  return { ...state, total, cart, totalAmount, totalPrice, allChecked: isAllChecked(cart) };
}
function calcaTotal(cart) {
  return cart.length;
}
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case actionTypes.INIT_CART:
      const total = calcaTotal(action.data.cart);
      return { totalAmount:0, totalPrice:0, total, cart: action.data.cart, allChecked:  false};
    case actionTypes.SET_CART:
      const result = calcaTotal(action.data.cart);
      return {  ...state, total: result, cart: action.data.cart };
    case actionTypes.TOGGLE_CHECK_ITEM:
      return handleToggleCheckItem(state, action);
    case actionTypes.TOGGLE_CHECK_ALL:
      return handleToggleCheckAll(state, action);
    case actionTypes.CHANGE_PRODUCT_NUMBER:
      return handleChangeProductNumber(state, action);
    case actionTypes.DELETE_PRODUCTS:
      return handleDeleteProducts(state, action);
    default:
      return state;
  }
}